import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideAnimations } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AsyncPipe } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';

//Components
import { BranchesComponent } from './components/branches/branches.component';
import { CartComponent } from './components/cart/cart.component';
import { CouponsComponent } from './components/coupons/coupons.component';
import { HomeComponent } from './components/home/home.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { DialogAskPoints, DialogInsufficientStock, PaymentComponent } from './components/payment/payment.component';
import { ProfileComponent, DialogChangePassword, DialogDeleteAccount, DialogEditProfile } from './components/profile/profile.component';
import { DialogTracking, SaleHistoryComponent } from './components/sale-history/sale-history.component';
import { DialogDetailProduct, StoreComponent } from './components/store/store.component';
import { BaseComponent, DialogConfirmCode, DialogLogin, DialogSaleResume, DialogSavedAddresses, DialogShippingType, DialogShowCoupons } from './components/base/base.component';
import { BarViewBranchComponent, DialogBranch } from './core-components/bar-view-branch/bar-view-branch.component';
import { DirectionsComponent, DialogAddAddress } from './components/directions/directions.component';
import { FamiliarsComponent, DialogAddFamily } from './components/familiars/familiars.component';

//Material
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {MatBadgeModule} from '@angular/material/badge';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatCardModule} from '@angular/material/card';
import {MatDividerModule} from '@angular/material/divider';
import {MatMenuModule} from '@angular/material/menu';
import {MatDialogModule} from '@angular/material/dialog';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule } from '@angular/material/input';
import {MatChipsModule} from '@angular/material/chips';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatSelectModule} from '@angular/material/select';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatTableModule} from '@angular/material/table';
import {MatPaginatorIntl, MatPaginatorModule} from '@angular/material/paginator';
import { ErrorStateMatcher, MAT_DATE_LOCALE, MatNativeDateModule, ShowOnDirtyErrorStateMatcher } from '@angular/material/core';
import { MatCheckboxModule } from '@angular/material/checkbox';


//OwlCarousel
import { CarouselModule } from 'ngx-owl-carousel-o';

// Extras
import { environment } from 'src/environments/environment';
import { AgmCoreModule } from '@agm/core';
import { NgxStripeModule } from 'ngx-stripe';
import { CookieService } from 'ngx-cookie-service';
import { FilterProductPipe } from './pipes/product-pipe-filter';
import { NgxBarcodeModule } from 'ngx-barcode';

// Directives
import { DefaultImageDirective } from './directives/default-image-product.directive';
import { LoadingOverlayComponent } from './components/loading-overlay/loading-overlay.component';
import { RedirectStoreComponent } from './components/redirect-store/redirect-store.component';
import { getCustomPaginatorIntl } from './custom/custom-paginator';
import { PromotionsComponent } from './components/promotions/promotions.component';
import { GoogleTagManagerModule } from 'angular-google-tag-manager';
import { PromoT1Component } from './components/promo-t1/promo-t1.component';
import { PromoT2Component } from './components/promo-t2/promo-t2.component';
import { PromoT3Component } from './components/promo-t3/promo-t3.component';
import { PromoT4Component } from './components/promo-t4/promo-t4.component';
import { PromoT5Component } from './components/promo-t5/promo-t5.component';
import { PromoT6Component } from './components/promo-t6/promo-t6.component';
import { AccessComponent } from './core-components/access/access.component';
import { DialogAddressComponent } from './components/base/dialog-address/dialog-address.component';
import { DialogNewAddressComponent } from './components/base/dialog-new-address/dialog-new-address.component';
import { FooterComponent } from './components/footer/footer.component';

@NgModule({
  declarations: [
    AppComponent,
    BranchesComponent,
    CartComponent,
    CouponsComponent,
    HomeComponent,
    NotFoundComponent,
    PaymentComponent,
    ProfileComponent,
    SaleHistoryComponent,
    StoreComponent,
    BaseComponent,
    BarViewBranchComponent,
    DialogLogin,
    DialogSaleResume,
    DialogDetailProduct,
    DialogBranch,
    DirectionsComponent,
    DialogAddAddress,
    FamiliarsComponent,
    DialogAddFamily,
    DialogConfirmCode,
    FilterProductPipe,
    DialogShippingType,
    DefaultImageDirective,
    LoadingOverlayComponent,
    RedirectStoreComponent,
    PromotionsComponent,
    DialogTracking,
    DirectionsComponent,
    FamiliarsComponent,
    DialogSavedAddresses,
    DialogAskPoints,
    DialogInsufficientStock,
    DialogChangePassword,
    PromoT2Component,
    PromoT4Component,
    PromoT1Component,
    PromoT3Component,
    PromoT5Component,
    PromoT6Component,
    AccessComponent,
    DialogAddressComponent,
    DialogNewAddressComponent,
    FooterComponent,
    DialogDeleteAccount,
    DialogShowCoupons,
    DialogEditProfile
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    MatBadgeModule,
    MatGridListModule,
    MatCardModule,
    MatDividerModule,
    MatMenuModule,
    MatDialogModule,
    CarouselModule,
    MatFormFieldModule,
    MatInputModule,
    MatChipsModule,
    MatPaginatorModule,
    MatTableModule,
    MatSnackBarModule,
    MatSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatButtonToggleModule,
    MatCheckboxModule,
    AgmCoreModule.forRoot({
      apiKey: environment.agm_apikey,
      libraries: ['places', 'geometry']
    }),
    NgxStripeModule.forRoot(environment.stripe_apikey),
    HttpClientModule,
    NgxBarcodeModule,
    GoogleTagManagerModule.forRoot({
      id: environment.ga4_measurement_id,
    })
  ],
  exports:[
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    MatBadgeModule,
    MatGridListModule,
    MatCardModule,
    MatDividerModule,
    MatMenuModule,
    MatDialogModule,
    CarouselModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
  ],
  providers: [
    provideAnimations(),
    CookieService,
    {
      provide: ErrorStateMatcher,
      useClass: ShowOnDirtyErrorStateMatcher
    },
    { provide: MatPaginatorIntl, 
      useValue: getCustomPaginatorIntl() 
    },
    { 
      provide: MAT_DATE_LOCALE, useValue: 'en-GB' 
    },
    AsyncPipe,
  ],
  entryComponents: [

  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
